export class Insured {
    public FirstName!: string;
    public LastName!: string;
    public DateOfBirth!: string;
    public Age!: number;
    public CoverageAmount!: number;
    public Deductible!: number;
    public MedicalSurvey: {};
    public MedicalSurveyCode=null;
    public IsPrimaryInsured!: boolean;

    constructor(){       
        this.Deductible=0;
        this.MedicalSurvey= {
            SurveyScore: null,
            ScoringReference: null,
            VerificationToken: null
        };
        this.MedicalSurveyCode=null;
    }
}